import { render, staticRenderFns } from "./LocationsCreateModal.vue?vue&type=template&id=537e501f&"
import script from "./LocationsCreateModal.vue?vue&type=script&lang=js&"
export * from "./LocationsCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports